import { assertUsage, hasProp } from './utils';
import { assertHook } from '../shared/getHook';
export { assertRenderHook };
function assertRenderHook(pageContext) {
    var _a;
    if (hasProp(pageContext.exports, 'render')) {
        assertHook(pageContext, 'render');
    }
    else {
        const pageClientsFilesLoaded = pageContext._pageFilesLoaded.filter((p) => p.fileType === '.page.client');
        let errMsg;
        if (pageClientsFilesLoaded.length === 0) {
            const url = (_a = pageContext.urlOriginal) !== null && _a !== void 0 ? _a : window.location.href;
            errMsg = 'No file `*.page.client.*` found for URL ' + url;
        }
        else {
            errMsg =
                'One of the following files should export a `render()` hook: ' +
                    pageClientsFilesLoaded.map((p) => p.filePath).join(' ');
        }
        assertUsage(false, errMsg);
    }
}
